// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1___de56a811af60b1cd3a0","cls2":"CreateSocialItemModal-cls2__ac93d7121a207f27dd97 CreateSocialItemModal-cls1___de56a811af60b1cd3a0"};